import { createSignal } from '../util/signals';

export type CrmTab = 'knowledge' | 'broadcast' | 'protocols' | 'settings';

export const [getIsCrmViewOpen, setIsCrmViewOpen] = createSignal<boolean>(false);
export const [getActiveCrmTab, setActiveCrmTab] = createSignal<CrmTab>('knowledge');
export const [getIsOperatorModalOpen, setIsOperatorModalOpen] = createSignal<boolean>(false);

export function openCrmTab(tab: CrmTab) {
  setActiveCrmTab(tab);
  setIsCrmViewOpen(true);
}

export function closeCrmView() {
  setIsCrmViewOpen(false);
}

export function openOperatorModal() {
  setIsOperatorModalOpen(true);
}

export function closeOperatorModal() {
  setIsOperatorModalOpen(false);
}
